import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { WarehouseTransfer } from '../entities/warehouse-transfer';



export class WarehouseTransferRequestDto extends BaseRequest {
    warehouseTransfer : WarehouseTransfer;
}

